import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";

// Initialize the highcharts-more module
HighchartsMore(Highcharts);

const PolarChart = ({ data, title }) => {
	const options = {
		chart: {
			polar: true,
			type: "line",
			backgroundColor: "transparent",
			style: {
				fontSize: "16px",
			},
		},
		title: {
			text: title,
		},
		pane: {
			size: "80%",
		},
		credits: {
			enabled: false,
		},
		xAxis: {
			categories: data.map((item) => item.name),
			tickmarkPlacement: "on",
			lineWidth: 0,
		},
		yAxis: {
			gridLineInterpolation: "polygon",
			lineWidth: 0,
			min: 0,
			max: 100,
			suffix: "%",
		},
		tooltip: {
			shared: true,
			pointFormat: '<span style="color:{series.color}">{series.name}: <b>' + "{point.y:,.0f}%</b><br/>",
		},
		legend: {
			enabled: false,
			align: "right",
			verticalAlign: "middle",
			layout: "vertical",
		},
		series: [
			{
				name: "Usage",
				data: data.map((item) => item.y),
				type: "area",
				fillOpacity: 0.3,
				lineWidth: 2.5,
				pointPlacement: "on",
				color: "#ff6b28",
				marker: {
					enabled: false, // Disables the markers (dots)
				},
			},
		],
		responsive: {
			rules: [
				{
					condition: {
						maxWidth: 400,
					},
					chartOptions: {
						legend: {
							align: "center",
							verticalAlign: "bottom",
							layout: "horizontal",
						},
						pane: {
							size: "65%",
						},
					},
				},
			],
		},
	};

	return (
		<div className="width-full">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default PolarChart;
